import _cloneDeep from 'lodash/cloneDeep';

export default class RolesController {
    /** @ngInject */
    constructor(RolesApi, UsersApi, DialogService, ToastService, $timeout, Loader, $q) {
        this.RolesApi = RolesApi;
        this.UsersApi = UsersApi;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.$timeout = $timeout;
        this.Loader = Loader;
        this.$q = $q;
    }

    $onInit() {
        this.roles = [];
        this.rolesFiltered = [];
        this.currentRole = null;
        this.currentRoleHistory = null;
        this.queryForSearchRoles = '';

        this.updateToast = this.createSimpleToast({
            text: 'Role was updated',
            position: 'bottom right',
            hideDelay: 3000
        });

        this.getRoles();
    }

    createSimpleToast(config) {
        return this.ToastService.createSimple(config);
    }

    getRoles() {
        return this.loadRoles().then(() => {
            this.filterRoles(this.queryForSearchRoles);
        });
    }

    loadRoles() {
        return this.RolesApi.getList().then((data) => {
            this.roles = data.roles || [];
            return this.roles;
        }, () => {
            this.roles = [];

            return this.roles;
        });
    }

    getRole(id) {
        return this.RolesApi.getRole(id).then((role) => {
            this.currentRole = role;
            this.currentRoleHistory = _cloneDeep(this.currentRole);
        });
    }

    onDeleteCurrentRole() {
        this.DialogService.confirm({
            title: 'Delete Role?',
            textContent: `Would you like to delete role "${this.currentRole.name}"?`,
            ariaLabel: 'delete-role',
            ok: 'Delete',
            cancel: 'Cancel'
        }).then(() => {
            this.RolesApi.deleteRole(this.currentRole.id).then(() => {
                // TODO: refactor when elastic will work correctly with cache
                this.$timeout(() => {
                    this.loadRoles().then(() => {
                        this.filterRoles(this.queryForSearchRoles);
                        this.currentRole = null;

                        if (this.Loader.isShowLoader()) {
                            this.Loader.hide();
                        }
                    });
                }, 1000);
            });
        });
    }

    onUpdateCurrentRole() {
        this.Loader.show();

        this.RolesApi.updateRole(this.currentRole.id, this.currentRole).then(() => {
            this.ToastService.show(
                this.updateToast
            );

            // TODO: refactor when elastic will work correctly with cache
            this.$timeout(() => {
                this.getRole(this.currentRole.id).then(() => {
                    this.Loader.hide();
                });
            }, 1000);
        });
    }

    onResetCurrentRole() {
        this.currentRole = _cloneDeep(this.currentRoleHistory);
    }

    addRole(item) {
        this.roles.unshift(item);
        this.filterRoles(this.queryForSearchRoles);
    }

    filterRoles() {
        const queryLowered = this.queryForSearchRoles.toLowerCase();

        this.rolesFiltered = queryLowered ? this.roles.filter((role) => {
            if (role.name.toLowerCase().indexOf(queryLowered) >= 0) {
                return true;
            }

            return false;
        }) : this.roles;
    }

    onRolesSelected({ entity }) {
        this.currentRole = entity;
        this.currentRoleHistory = _cloneDeep(this.currentRole);
    }

    onRoleCreate({ name }) {
        const newRole = {
            name
        };

        this.RolesApi.createRole(newRole).then((role) => {
            if (typeof role === 'object') {
                this.addRole(role);
            }
        }, (error) => {
            this.DialogService.show({
                clickOutsideToClose: true,
                title: 'Error',
                textContent: error.Error,
                ariaLabel: 'Error message',
                ok: 'Close'
            });
        });
    }

    onRemoveUser({ user }) {
        if (user && user.id) {
            this.Loader.show();

            this.RolesApi.deleteUsersFromRole(this.currentRole.id, [user.id.toString()]).then(() => {
                // TODO: refactor when elastic will work correctly with cache
                this.$timeout(() => {
                    const rolesPromise = this.getRoles();
                    const rolePromise = this.getRole(this.currentRole.id);

                    this.$q
                        .all({
                            rolesPromise,
                            rolePromise
                        })
                        .then(() => {
                            this.Loader.hide();
                        });
                }, 1000);
            });
        }
    }

    onAddUser({ user }) {
        if (user && user.id) {
            this.Loader.show();

            this.RolesApi.addUsersToRole(this.currentRole.id, [user.id.toString()]).then(() => {
                // TODO: refactor when elastic will work correctly with cache
                this.$timeout(() => {
                    const rolesPromise = this.getRoles();
                    const rolePromise = this.getRole(this.currentRole.id);

                    this.$q
                        .all({
                            rolesPromise,
                            rolePromise
                        })
                        .then(() => {
                            this.Loader.hide();
                        });
                }, 1000);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/roles.controller.js